import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Alert } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from '../dashboard/useAuth';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'


const ActivationPage = () => {
  useAuth()
  const location = useLocation();
  const navigate = useNavigate();
  const { user, userId, titre } = location.state || {}; // Récupère user et userId
  const [value, setValue] = useState()

  const [formData, setFormData] = useState({
    nom: user?.family_name || '',
    prenom: user?.given_name || '',
    email: user?.email || '',
    tel: '',
    profession: '',
    diplome: '',
    formation: '',
    sexe: '',
    mdp1: '',
    mdp2: '',
  });

  const [messages, setMessages] = useState([]);
  const [passwordConditions, setPasswordConditions] = useState({
    minLength: false,
    hasUppercase: false,
    hasNumber: false,
    hasSpecialChar: false,
  });

  useEffect(() => {

    setFormData({
      nom: user?.family_name || '',
      prenom: user?.given_name || '',
      email: user?.email || '',
      tel: '',
      profession: '',
      diplome: '',
      formation: '',
      sexe: '',
      mdp1: '',
      mdp2: '',
    });
  }, [user, userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === 'mdp1') {
      checkPasswordStrength(value);
    }
  };

  const checkPasswordStrength = (password) => {
    setPasswordConditions({
      minLength: password.length >= 8,
      hasUppercase: /[A-Z]/.test(password),
      hasNumber: /[0-9]/.test(password),
      hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    });
  };

  const [formation, setFormation] = useState([]);
  // Fetching formations data from API
  const fetchFormation = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_HOTE + '/liste-formation/');
      if (response.ok) {
        const data = await response.json();
        setFormation(data);
      } else {
        console.error('Erreur lors de la récupération des formations');
      }
    } catch (error) {
      console.error('Erreur réseau:', error);
    }
  };
  useEffect(() => {
    fetchFormation();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(process.env.REACT_APP_HOTE + `/activer-compte/${userId}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        setMessages(['Activation réussie !']); // Montre un message de succès

        // Redirection vers le Dashboard avec l'userId dans l'URL
        navigate(`/papachigan`, { state: { user, titre } });
      } else {
        // Gère les réponses d'erreur du backend
        setMessages([result.message || 'Erreur lors de l\'activation']);
      }
    } catch (error) {
      console.error('Error:', error);
      setMessages(['Erreur de connexion au serveur.']);
    }
  };

  // Inline style pour l'arrière-plan
  const pageStyle = {
    backgroundColor: '#f5f7fa',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const messageStyle = {
    textAlign: 'left',
    marginBottom: '8px',
    marginTop: '8px',
  };

  const getConditionClass = (condition) => condition ? 'text-success' : 'text-default';

  // Gérer les changements du champ de téléphone (numéro complet + indicatif pays)

  const handlePhoneChange = (value) => {
    setFormData({
      ...formData,
      tel: value, // Numéro formaté
    });
  };


  return (
    <div style={pageStyle}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div className="text-center loginscreen animated fadeInDown">
              <div className="ibox-content p-4 shadow rounded">
                <div className="mb-4">
                  <i className="fa fa-user-circle login-logo" style={{ fontSize: '50px' }}></i>
                </div>
                <h3 className="font-bold">Complétez votre profil</h3>
                <p className="text-muted">Veuillez entrer vos informations</p>

                {messages.length > 0 && (
                  <div className="alert alert-success">
                    {messages.map((msg, index) => (
                      <p key={index}>{msg}</p>
                    ))}
                  </div>
                )}

                <form className="m-t" role="form" onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="form-group col-md-6">
                      <label className="sr-only">Nom</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Nom"
                        required
                        name="nom"
                        value={formData.nom}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="sr-only">Prénom</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Prénom"
                        required
                        name="prenom"
                        value={formData.prenom}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group col-md-6">
                      <label className="sr-only">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>

                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="tel">
                        <PhoneInput
                          value={formData.tel}
                          onChange={handlePhoneChange}
                          inputStyle={{ width: '100%' }}
                          containerStyle={{ width: '100%' }}
                          required
                          inputProps={{
                            name: 'tel',
                            required: true,
                          }}
                          dropdownStyle={{
                            maxHeight: '200px',
                            overflowY: 'auto',
                            zIndex: 1050,
                          }}
                        />
                      </Form.Group>
                    </Col>

                  </div>

                  <div className="form-row">
                    <div className="form-group col-md-6">
                      <label className="sr-only">Profession</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Profession"
                        required
                        name="profession"
                        value={formData.profession}
                        onChange={handleChange}
                      />
                    </div>
                     <div className="form-group col-md-6">
                      <label className="sr-only">Sexe</label>
                      <select
                        className="form-control"
                        required
                        name="sexe"
                        value={formData.sexe}
                        onChange={handleChange}
                      >
                        <option value="">Sélectionnez le sexe</option>
                        <option value="Masculin">Masculin</option>
                        <option value="Féminin">Féminin</option>
                      </select>
                    </div>
                    {/* <div className="form-group col-md-6">
                      <label className="sr-only">Diplôme</label>
                      <select
                        className="form-control"
                        required
                        name="diplome"
                        value={formData.diplome}
                        onChange={handleChange}
                      >
                        <option value="">Diplôme le plus élevé</option>
                        <option value="BAC">BAC</option>
                        <option value="BTS">BTS</option>
                        <option value="Licence">Licence</option>
                        <option value="Master1">Master1</option>
                        <option value="Master2">Master2</option>
                        <option value="Doctorat">Doctorat</option>
                        <option value="Ingénieur">Ingénieur</option>
                        <option value="Autres">Autres</option>
                      </select>
                    </div> */}
                  </div>

                  <div className="form-row">
                    {/* <div className="form-group col-md-6">
                      <label className="sr-only">Formation</label>
                      <select
                        className="form-control"
                        required
                        name="formation"
                        value={formData.formation}
                        onChange={handleChange}
                      >
                        <option value="">Choisir une formation</option>
                        {formation.map((formation) => (
                          <option key={formation.id} value={formation.nom}>
                            {formation.nom} {formation.option}
                          </option>
                        ))}
                      </select>
                    </div> */}
                  </div>

                  <button type="submit" className="btn btn-success block full-width m-b">Enregistrer</button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <p className="text-center">
          <small>Inovact &copy; 2024. Tous droits réservés.</small>
        </p>
      </div>
    </div>
  );
};

export default ActivationPage;
